import React from 'react'
import TextEditor from '../../common/TextEditor'

function CommunityGuidelines() {
  return (
    <div className="main-content">
      <div className="container-fluid">
        <div className='d-flex justify-content-between'>
          <ul className="nav nav-tabs">
            <li className="nav-item">
              <button
                className={`nav-link active`}
              >
                Community guidelines
              </button>
            </li>


          </ul>
        </div>
        <TextEditor type={"communityGuidelines"} />
      </div>


    </div>
  )
}

export default CommunityGuidelines